import type {State} from 'src/reducers';
import type {AudienceListTableEntry} from 'src/types/audience-list';
/*
 * Base Selectors
 */

export const selectLists = (state: State): AudienceListTableEntry[] =>
  state.audienceLists.lists;
export const selectListsMapAcrossPages = (
  state: State,
): Map<string, AudienceListTableEntry[]> =>
  // @ts-expect-error - TS2339 - Property 'listsMap' does not exist on type 'never'.
  state.audienceLists.listsMap;

export const selectTotal = (state: State): number => state.audienceLists.total;
export const selectRefetch = (state: State): number =>
  // @ts-expect-error - TS2339 - Property 'refetch' does not exist on type 'never'.
  state.audienceLists.refetch;

//NOTE:(diwakersurya) this selector helps the lists page to know when to reset the lists
//local reducer state because the lists can be created from from side panel but since
//the lists page is in background, it needs to update to show the latest lists including
//the one created right now.
export const selectResetListPageState = (state: State): number =>
  // @ts-expect-error - TS2339 - Property 'resetListPageState' does not exist on type 'never'.
  state.audienceLists.resetListPageState;
